import { useEffect, useRef, useState } from 'react';

const OFFSET = 70 + 32 + 32 + 51 + 14.75 + 9.5 + 68 + 20;

const DEFAULT_OFFSET = OFFSET + 65;

export const useTableOffset = () => {
  const controlsRef = useRef<HTMLDivElement | null>(null);

  const [controlsHeight, setControlsHeight] = useState<number | null>(null);

  const offset = controlsHeight ? OFFSET + controlsHeight : DEFAULT_OFFSET;

  const updateControlsHeight = () => setControlsHeight(controlsRef.current?.clientHeight || null);

  useEffect(() => {
    if (!controlsRef.current) return;

    const resizeObserver = new ResizeObserver(updateControlsHeight);

    resizeObserver.observe(controlsRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  return { controlsRef, offset };
};
